<template>
  <section class="section hero">
    <div
      :style="style"
      class="hero__image"
      data-ui="event-details-hero-image"
    />
  </section>
</template>

<script>
import metrics from '../mixins/metrics';

export default {
  name: 'SessionHeroComponent',
  mixins: [metrics],
  props: {
    baseImageUri: {
      type: String,
      required: true,
    },
  },
  computed: {
    style() {
      const { baseImageUri } = this;
      return { backgroundImage: `url(${baseImageUri})` };
    },
  },
  methods: {
    handleClick() {
      this.metricsClick({ linkName: '{{ pageName }}_hero_View registration summary' });
    },
  },
};
</script>
